var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSparklesBig(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3915_2018)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.48438 23.25C8.48438 17.3123 5.2755 12 0.75 12C5.2755 12 8.48438 6.68737 8.48438 0.75C8.48438 6.68737 11.6932 12 16.2188 12C11.6932 12 8.48438 17.3123 8.48438 23.25Z",
    fill: "url(#paint0_linear_3915_2018)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6252 12C17.6252 9.03075 16.0213 6.375 13.7578 6.375C16.0213 6.375 17.6252 3.7185 17.6252 0.75C17.6252 3.7185 19.2291 6.375 21.4926 6.375C19.2291 6.375 17.6252 9.03075 17.6252 12Z",
    fill: "url(#paint1_linear_3915_2018)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.383 23.25C19.383 20.2811 17.7791 17.625 15.5156 17.625C17.7787 17.625 19.383 14.9685 19.383 12C19.383 14.9685 20.9869 17.625 23.2504 17.625C20.9869 17.625 19.383 20.2811 19.383 23.25Z",
    fill: "url(#paint2_linear_3915_2018)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3915_2018",
    x1: 8.48437,
    y1: 0.75,
    x2: 8.48438,
    y2: 23.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#90205D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EE4352",
    stopOpacity: 0.969
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3915_2018",
    x1: 17.6252,
    y1: 0.75,
    x2: 17.6252,
    y2: 12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#90205D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EE4352",
    stopOpacity: 0.969
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3915_2018",
    x1: 19.383,
    y1: 12,
    x2: 19.383,
    y2: 23.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#90205D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EE4352",
    stopOpacity: 0.969
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3915_2018"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "matrix(1 0 0 -1 0 24)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSparklesBig);
export default __webpack_public_path__ + "static/media/sparklesBig.053a970a.svg";
export { ForwardRef as ReactComponent };